(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyUiSelectValidateVehicleField", [
    "$location",
    function ($location) {
      return {
        restrict: "A",
        require: "uiSelect",
        scope: true,
        link: function ($scope, $element) {
          var uiSelectController = angular.element($element).controller("uiSelect");

          var CAR_SELECTION_ONE_PARAM_KEY = "CarSelectionOne";
          var carSelectionOneParam = $location.search()[CAR_SELECTION_ONE_PARAM_KEY];

          if (carSelectionOneParam) {
            var vehicleModelList = $scope.$parent.vehicleModelList[0];
            var vehiclesList = $scope.$parent.vehiclesList;
            var vehicleParamExists = vehiclesList.find(function (vehicle) {
              return vehicle.Text === carSelectionOneParam;
            });

            if ($element[0].id === vehicleModelList && vehicleParamExists) {
              uiSelectController.open = true;
              uiSelectController.activate();
              uiSelectController.close();
            }
          }
        },
      };
    },
  ]);
})(window.angular);
